import React from 'react';
import * as S from './styles';

export const HeadersModalLoginQueues = ({
  isChat = false,
  extensionName = ''
}) => {
  const title = isChat ? 'Agente: ' : 'Código do Agente: ';
  return (
    <S.InfoWrapper>
      <S.UserInfoWrapper title={title}>
        <S.Label>{title}</S.Label>
        <S.Info>
          {isChat
            ? localStorage.getItem('name')
            : localStorage.getItem('agent_code')}
        </S.Info>
      </S.UserInfoWrapper>
      {!isChat && (
        <S.UserInfoWrapper title="Ramal">
          <S.Label>Ramal: </S.Label>
          <S.Info>{extensionName || ''}</S.Info>
        </S.UserInfoWrapper>
      )}
    </S.InfoWrapper>
  );
};
